import type { CustomerData } from './addUserTypes';

export function buildKnownPlantIdSet(customersAndSites: CustomerData[]): Set<string> {
    const plantIds = new Set<string>();
    for (const customer of customersAndSites) {
        for (const site of customer.sitesAndPlants) {
            for (const plant of site.plants) {
                plantIds.add(plant.plantId);
            }
        }
    }
    return plantIds;
}
